import { render, staticRenderFns } from "./examMarks.vue?vue&type=template&id=1aa2ba36&scoped=true&"
import script from "./examMarks.vue?vue&type=script&lang=js&"
export * from "./examMarks.vue?vue&type=script&lang=js&"
import style0 from "./examMarks.vue?vue&type=style&index=0&id=1aa2ba36&lang=scss&scoped=true&"
import style1 from "./examMarks.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./examMarks.vue?vue&type=style&index=2&id=1aa2ba36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2ba36",
  null
  
)

export default component.exports